import { connect, MapStateToProps, MergeProps } from "react-redux";

import { composeQA } from "@multiweb/reactUtils";
import { IAppState } from "@multiweb/types/react";
import {
    getColumnAggregationResult,
    getColumnAttributeName,
    getColumnType,
    getColumnWidth,
    isColumnResultLoading,
} from "../../selectors";
import { Column as AggregationRowColumn, ColumnType } from "../../types";
import { ColumnComponent, ColumnComponentProps } from "../ColumnComponent";

type ColumnProps = {
    /** Klíč sloupce. */
    columnKey: string;
    /** Klíč agregačního řádku. */
    aggregationRowKey: string;
};

type StateProps = Pick<ColumnComponentProps, "width" | "isLoading" | "columnType" | "aggregationResult"> & Pick<AggregationRowColumn, "attributeName">;

const mapStateToProps: MapStateToProps<StateProps, ColumnProps, IAppState> = (state, { columnKey, aggregationRowKey }) => {
    const columnType = getColumnType(state, { columnKey, aggregationRowKey });
    const width = getColumnWidth(state, { columnKey, aggregationRowKey });
    const attributeName = getColumnAttributeName(state, { columnKey, aggregationRowKey }) || null;
    const commonProps = { columnType, attributeName, width };
    return columnType === ColumnType.numeric ? {
        ...commonProps,
        isLoading: isColumnResultLoading(state, { columnKey, aggregationRowKey }),
        aggregationResult: getColumnAggregationResult(state, { columnKey, aggregationRowKey }),
    } : {
        ...commonProps,
        isLoading: false,
        aggregationResult: undefined,
    };
};

const mergeProps: MergeProps<StateProps, undefined, ColumnProps, ColumnComponentProps> = (
    { attributeName, ...restStateProps },
    _dispatchProps,
    { columnKey, aggregationRowKey },
) => ({
    ...restStateProps,
    aggregationRowKey,
    columnKey,
    qa: composeQA(attributeName || columnKey),
});

export const Column = connect(mapStateToProps, undefined, mergeProps)(ColumnComponent);
